<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav :menuItems="menuItems" class="side-nav"></side-nav>

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

export default {
  name: 'Derbies',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Скачки',
          route: {name: 'derby_list'},
          exact: true,
        },
        {
          title: 'Шаблоны',
          route: {name: 'derby_template_list'},
        }
      ];

      return items;
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>
